<template>
	<LayoutFormInputGeneral :inputId="inputId" :title="title" :subtitle="subtitle">
		<div class="vstack gap-5">
			<div class="d-flex flex-column flex-md-row gap-3" v-for="(exchange, index) in exchanges" v-bind:key="index">
				<div class="hstack gap-3">
					<div class="flex-fill w-50">
						<CommonFormInputSelect v-model="exchange.from" placeholder="Seleccionar moneda" :options="$env.GENERAL.currencies" />
					</div>
					<div>
						<i class="bi bi-chevron-double-right"></i>
					</div>
					<div class="flex-fill w-50">
						<CommonFormInputSelect v-model="exchange.to" placeholder="Seleccionar moneda" :options="$env.GENERAL.currencies" />
					</div>
				</div>
				<div class="hstack gap-3">
					<div class="d-none d-md-inline">
						<i class="bi bi-currency-exchange"></i>
					</div>
					<div class="flex-fill w-50">
						<CommonFormInputAmount v-model="exchange.rate" :precision="8" placeholder="Ingresar el tipo de cambio" />
					</div>
					<div>
						<button type="button" class="btn btn-square btn-neutral" @click="remove(index)"><i class="bi bi-trash"></i></button>
					</div>
				</div>
			</div>
			<a href="javascript:void(0);" class="link-primary" @click="add"><i class="bi bi-plus pe-1"></i>Agregar tipo de cambio</a>
		</div>
	</LayoutFormInputGeneral>
</template>

<script>
	import { computed } from 'vue';
	import _ from 'lodash';

	export default {
		props: {
			exchanges: Array,
			title: String,
			subtitle: String,
			placeholder: String
		},
		setup(props, { emit }) {
			const inputId = `input-${Math.random().toString(36).substr(2, 9)}`;

			const add = () => {
				props.exchanges.push({
					from: null,
					to: null,
					rate: null
				});
			}

			const remove = (index) => {
				_.pullAt(props.exchanges, index);
			}

			return { inputId, add, remove };
		}
	}
</script>